import { AlertCircle } from 'lucide-react';
import { useCatalogFromStorage } from '@/hooks/useCatalogAuth';
import CatalogView from '@/components/catalog/CatalogView';

const CATALOG_TOKEN_KEY = 'catalog_access_token';

export default function CatalogPage() {
  const { isLoading, isValid, eventId } = useCatalogFromStorage();
  const storedToken = localStorage.getItem(CATALOG_TOKEN_KEY) ?? '';

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isValid) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-card rounded-ds-card shadow-lg p-6 max-w-md w-full text-center">
          <AlertCircle className="mx-auto mb-4 text-status-danger" size={48} />
          <h1 className="text-xl font-bold text-foreground mb-2">Catálogo não encontrado</h1>
          <p className="text-muted-foreground mb-4">
            O link do catálogo é inválido ou o catálogo não está disponível.
          </p>
        </div>
      </div>
    );
  }

  return <CatalogView eventId={eventId!} storedToken={storedToken} />;
}
